import { Injectable } from '@angular/core';
import { environment } from './environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Environments } from './app/@core/constants/Environments';
import { Tokens } from './app/@core/constants/Tokens';

@Injectable({
    providedIn: 'root'
})
export class AppConfig {

    //config properties go here

    load() {
        return new Promise(async (resolve, reject) => {
            var url = "assets/config/config.local.json?cb=" + new Date().getTime();
            if (environment.production) {
                url = "assets/config/config.deploy.json?cb=" + new Date().getTime();
            }
            await this.http
                .get(url)
                .subscribe((envResponse: any) => {
                    //set the value of config properties here
                    environment.production = envResponse.production;
                    environment.apiUrl = envResponse.apiUrl;
                    environment.env = envResponse.env;
                    environment.authToken = environment.env == Environments.PROD ? Tokens.PROD : Tokens.TEST;
                    resolve(true);

                }, (error) => {
                    console.log("Configuration file could not be read");
                    resolve(true);
                    return Observable.throw(error.json().error || "Server error");
                });
        });
    }

    constructor(private http: HttpClient) { }
}
